import { Tabs } from "@mantine/core";
import { IconBook, IconChartAreaLine, IconChartBar, IconChartPie, IconFileAnalytics, IconLeaf } from "@tabler/icons-react";
import { useSearchParams } from "react-router";

import { useModules } from "../../auth/modules";
import { useCan } from "../../auth/user";
import { useT } from "../../i18n/script";
import IndicesPage from "../IndicesPage";
import DiaryOverviewPage from "../orchard/DiaryOverviewPage";
import PhenologyOverviewPage from "../orchard/PhenologyOverviewPage";
import StatsPage from "../public/StatsPage";
import ReportsPage from "../reports/ReportsPage";
import AnalyticsPage from "./AnalyticsPage";

/** Jedna stavka menija za sve preglede preko više gazdinstava: analitika, izvještaji, evidencije, indeksi, statistika. */
export default function AnalyticsHub() {
  const { t } = useT();
  const can = useCan();
  const hasModule = useModules();
  const [params, setParams] = useSearchParams();
  const tabs = [
    { v: "analitika", l: "Analitika i predikcije", i: <IconChartBar size={15} />, ok: can("analytics:read") && hasModule("vocarstvo"), c: <AnalyticsPage /> },
    { v: "izvjestaji", l: "Izvještaji", i: <IconFileAnalytics size={15} />, ok: can("reports:read"), c: <ReportsPage /> },
    { v: "fenologija", l: "Fenologija — usklađenost", i: <IconLeaf size={15} />, ok: can("phenology:read"), c: <PhenologyOverviewPage /> },
    { v: "knjiga", l: "Poljoprivredna knjiga — pregled", i: <IconBook size={15} />, ok: can("diary:read"), c: <DiaryOverviewPage /> },
    { v: "indeksi", l: "Spektralni indeksi", i: <IconChartAreaLine size={15} />, ok: can("indices:read") && hasModule("vocarstvo"), c: <IndicesPage /> },
    { v: "statistika", l: "Javna statistika", i: <IconChartPie size={15} />, ok: can("stats:public"), c: <StatsPage embedded /> },
  ].filter((x) => x.ok);
  const cur = tabs.find((x) => x.v === params.get("tab"))?.v ?? tabs[0]?.v ?? null;
  return (
    <Tabs value={cur} onChange={(v) => v && setParams({ tab: v }, { replace: true })} keepMounted={false} variant="pills" radius="xl">
      <Tabs.List mb="md">
        {tabs.map((x) => <Tabs.Tab key={x.v} value={x.v} leftSection={x.i}>{t(x.l)}</Tabs.Tab>)}
      </Tabs.List>
      {tabs.map((x) => <Tabs.Panel key={x.v} value={x.v}>{x.c}</Tabs.Panel>)}
    </Tabs>
  );
}
